import localforage from 'localforage'
import axios from 'axios'
import {router} from "../router";
import store from "../store";
export const deliveries = {
    state: {
        deliveries: null,
        deliveryDay: null,
        loadingStatus: 'notLoading',
        currentDelivery: null,
        isScrollingToDelivery: false,
        deliveryCancellationReasons: null,
        deliveryDate: null,
        responseDate: null
    },
    mutations: {
        SET_LOADING_STATUS(state, status){
            state.loadingStatus = status
        },
        SET_DELIVERIES(state, content) {
            state.deliveries = content
        },
        SET_DELIVERY_DAY(state, content) {
            state.deliveryDay = content
        },
        SET_RESPONSE_DATE(state, content) {
            state.responseDate = content
        },
        SET_CURRENT_DELIVERY(state, currentDelivery) {
            state.currentDelivery = currentDelivery
        },
        SET_SCROLLING_STATUS(state, isScrollingToDelivery) {
            state.isScrollingToDelivery = isScrollingToDelivery
        },
        SET_DELIVERY_CANCELLATION_REASONS(state, deliveryCancellationReasons){
            state.deliveryCancellationReasons = deliveryCancellationReasons
        },
        SET_DELIVERY_DATE(state, content) {
            state.deliveryDate = content
        }
    },
    actions: {
        fetchDeliveries({ state, commit }) {
            // prevent multiple requests at same time
            if(state.loadingStatus === 'loading')
                return
            commit('SET_LOADING_STATUS', 'loading')
            return localforage.getItem('authUser').then((headers) => {
                return axios.post( process.env.VUE_APP_API+'deliveries', {
                        browser_data: {user_agent: navigator.userAgent, platform: navigator.platform, app_number: process.env.PACKAGE_VERSION}
                    },{headers: JSON.parse(headers)})
                .then((response) => {
                    commit('SET_DELIVERIES', Object.freeze(response.data.data))
                    commit('SET_LOADING_STATUS', 'notLoading')
                    localforage.setItem('deliveries', response.data.data);
                    commit('SET_DELIVERY_DAY', response.data.delivery_day)
                    commit('SET_RESPONSE_DATE', response.data.response_date)
                })
                .catch(() => {
                    // load from local storage
                    console.log('Reading from local storage');
                    localforage.getItem('deliveries').then(deliveries => {
                        commit('SET_DELIVERIES', Object.freeze(deliveries))
                        commit('SET_LOADING_STATUS', 'notLoading')
                    })
                })
            })
        },
        setCurrentDelivery({ commit }, payload) {
            commit('SET_CURRENT_DELIVERY', payload)
        },
        setScrollingStatus({ commit }, payload) {
            commit('SET_SCROLLING_STATUS', payload)
        },
        sendConfirmDelivery({ dispatch, getters }, payload) {
            // action for devices that do not support pwa
            localforage.getItem('authUser').then((headers) => {
                return axios({
                    method: 'PATCH',
                    url: `${process.env.VUE_APP_API}deliveries/${payload.id}`,
                    headers: JSON.parse(headers),
                    data: {
                        delivered: payload.delivered,
                        timestamp: Math.round(Date.now() / 1000),
                        cancellationReason: payload.cancellationReason,
                        geolocation: getters.getGeolocation
                    }
                }
                ).then((response) => {
                    if(response.status === 200){
                        dispatch('addNotification', {
                            type: 'success',
                            title: 'Potwierdzenie wysłania',
                            content: 'Potwierdzenie zostało wysłane'
                        })
                        // hide modal
                        dispatch('hideModal')
                        dispatch('fetchDeliveries')
                    } else {
                        dispatch('pendingModal', false)
                        console.error(response);
                    }
                })
                .catch((error) => {
                    dispatch('pendingModal', false)
                    console.log(error);
                })
            })
        },
        confirmDelivery({ dispatch, getters }, payload) {
            // if delivered then alter item from local storage
            if(payload.delivered){
                localforage.getItem('deliveries').then(deliveries => {
                    if(deliveries) {
                        deliveries.find(delivery => {
                            if (delivery.id === payload.id) {
                                delivery.delivered = true
                            }
                        })
                    }
                    localforage.setItem('deliveries', deliveries)
                })
            }
            // check if device support sevice worker
            if('serviceWorker' in navigator && 'SyncManager' in window){
                navigator.serviceWorker.ready.then(sw => {
                    // check if array with confirmations already exists
                    return localforage.getItem('confirmations').then(confirmations => {
                        // if it is 1st element
                        if(confirmations === null){
                            confirmations = new Array()
                        }
                        if(confirmations.find(confirmation => confirmation.id == payload.id && confirmation.delivered == true)){
                            // confirmation for this ID already exist, abort
                            console.error(`Confirmation for this ID (${payload.id}) already exist, aborting`)
                            return sw.sync.register('sync-confirmations')
                        }
                        // add confirmation at the beginning of array
                        confirmations.unshift({
                            id: payload.id,
                            delivered: payload.delivered,
                            timestamp: Math.round(Date.now() / 1000),
                            cancellationReason: payload.cancellationReason,
                            geolocation: getters.getGeolocation
                        })
                        // save to iDB
                        return localforage.setItem('confirmations', confirmations).then(() => {
                            // we're ready to send confirmations, but if there is no internet then push notification about it
                            if(navigator.onLine === false){
                                dispatch('addNotification', {
                                    type: 'warning',
                                    title: 'Błąd połączenia',
                                    content: 'Nie mozna połaczyć się z serwerem. Aplikacja zapisze dane w pamięci podręcznej i zsynchronizuje w momencie połączenia odzyskania połączenia z internetem.'
                                })
                                dispatch('hideModal')
                            }
                            return sw.sync.register('sync-confirmations')
                        })
                    })
                })
                .then(() => console.log('Registered background sync'))
                .catch(err => console.error('Error registering background sync', err))
            } else {
                dispatch('sendConfirmDelivery', payload)
            }
        },
        rollbackDelivery({ dispatch, getters }, payload) {
            // if delivered then alter item from local storage
            if(!payload.delivered){
                localforage.getItem('deliveries').then(deliveries => {
                    if(deliveries) {
                        deliveries.find(delivery => {
                            if (delivery.id === payload.id) {
                                //delivery.delivered = false
                                delivery.to_verification = true
                            }
                        })
                    }
                    localforage.setItem('deliveries', deliveries)
                })
            }
            // check if device support sevice worker
            if('serviceWorker' in navigator && 'SyncManager' in window){
                navigator.serviceWorker.ready
                .then(sw => {
                    // check if array with confirmations already exists
                    localforage.getItem('confirmations').then(confirmations => {
                        // if it is 1st element
                        if(confirmations === null){
                            confirmations = new Array()
                        }
                        if(confirmations.find(confirmation => confirmation.id == payload.id && confirmation.delivered == false)){
                            // confirmation for this ID already exist, abort
                            console.error(`Confirmation for this ID (${payload.id}) already exist, aborting`);
                            return
                        }
                        // add confirmation at the beginning of array
                        confirmations.unshift({
                            id: payload.id,
                            delivered: payload.delivered,
                            cancellationReason: payload.cancellationReason,
                            geolocation: getters.getGeolocation
                        })
                        // save to iDB
                        localforage.setItem('confirmations', confirmations).then(() => {
                            // we're ready to send confirmations, but if there is no internet then push notification about it
                            if(navigator.onLine === false){
                                dispatch('addNotification', {
                                    type: 'warning',
                                    title: 'Błąd połączenia',
                                    content: 'Nie mozna połaczyć się z serwerem. Aplikacja zapisze dane w pamięci podręcznej i zsynchronizuje w momencie połączenia odzyskania połączenia z internetem.'
                                })
                                dispatch('hideModal')
                            }
                            return sw.sync.register('sync-confirmations')
                        })
                    })
                })
            } else {
                dispatch('sendConfirmDelivery', payload)
            }
        },
        addNote({ dispatch }, payload) {
            dispatch('checkTokenValidity').then(() => {
                localforage.getItem('authUser').then((headers) => {
                    if (headers) {
                        return axios.post(`${process.env.VUE_APP_API}delivery_note/${payload.id}`, {
                            note: payload.textarea
                        }, {
                            headers: JSON.parse(headers)
                        })
                            .then((response) => {
                                if(response.status === 200){
                                    dispatch('addNotification', {
                                        type: 'success',
                                        title: 'Potwierdzenie dodania uwagi',
                                        content: 'Uwaga dodana poprawnie'
                                    })
                                    dispatch('hideModal')
                                    dispatch('fetchDeliveries')
                                } else {
                                    dispatch('pendingModal', false)
                                    console.error(response);
                                }
                            })
                            .catch((e) => {
                                console.log(e);
                            })
                    }
                })
            }).catch(error => {
                router.push({name: 'logout'})
                store.dispatch('addNotification', {
                    type: 'warning',
                    content: error
                })
            })
        },
        discardDelivery({ dispatch }) {
            // send confirm to server
            dispatch('addNotification', {
                type: 'success',
                title: 'Potwierdzenie wysłania',
                content: 'Potwierdzenie zostało wysłane'
            })
            // hide modal
            dispatch('hideModal')
        },
        fetchDeliveryCancellationReasons({ commit }){
            return localforage.getItem('authUser').then((headers) => {
                return axios.get( process.env.VUE_APP_API+'deliveryCancellationReasons', {headers: JSON.parse(headers) })
                .then((response) => {
                    commit('SET_DELIVERY_CANCELLATION_REASONS', Object.freeze(response.data.data))
                })
                .catch((e) => {
                    console.log(e);
                })
            })
        }
    },
    getters: {
        getDeliveries: (state) => {
            if(state.deliveries){
                return state.deliveries.filter(delivery => JSON.parse(delivery.delivered) === false)
            }
        },
        getDelivered: (state) => {
            if(state.deliveries){
                return state.deliveries.filter(delivery => JSON.parse(delivery.delivered) === true)
            }
        },
        getTotalDeliveries: (state) => {
            if(state.deliveries){
                return state.deliveries.length
            }
        },
        getTotalDelivered: (state) => {
            if(state.deliveries){
                return state.deliveries.filter(delivery => JSON.parse(delivery.delivered) === true).length
            }
        },
        getCurrentDelivery: (state) => {
            return state.currentDelivery
        },
        isScrollingToDelivery: (state) => {
            return state.isScrollingToDelivery
        },
        getLoadingStatus: (state) => {
            return state.loadingStatus
        },
        getDeliveryCancellationReasons: (state) => {
            return state.deliveryCancellationReasons
        },
        getTimeNow: (state) => {
            return state.deliveryDay
        },
        getResponseDate: (state) => {
            return state.responseDate
        }
    }
}
